// i18n namespace "clients" (runtime top-level key: `testimonials`; spec c.7 §7).
// COO decision 3: ALL quotes OFF, so no quote text exists in any language. The section
// renders nothing until a client in src/content/clients.ts has quoteConsent + person + titleKey;
// add that quote's text and title keys here, in all four languages, at the same time.

export const en = {
  label: "Client",
  srTitle: "What a client says",
};

export const es = {
  label: "Cliente",
  srTitle: "Lo que dice un cliente",
};

export const fr = {
  label: "Client",
  srTitle: "Ce que dit un client",
};

export const pt = {
  label: "Cliente",
  srTitle: "O que diz um cliente",
};
